import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { serviceActions } from './async-actions';
import { CasesState, ISupportCase, ISupportCaseDetail, initialState } from './types';

const casesSlice = createSlice({
  name: 'cases',
  initialState,
  reducers: {
    setCases(state, action: PayloadAction<ISupportCase[]>) {
      state.cases = action.payload;
    },
    setSelectedCase(state, action: PayloadAction<ISupportCaseDetail>) {
      state.selectedCase = action.payload;
    },
    clearSelectedCase(state) {
      state.selectedCase = null;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setDetailLoading(state, action: PayloadAction<boolean>) {
      state.detailLoading = action.payload;
    },
    setServiceFailure(state, action: PayloadAction<boolean>) {
      state.serviceFailure = action.payload;
    },
  },
});

export const { name: casesSliceKey, reducer: casesReducer } = casesSlice;
export const casesActions = { ...casesSlice.actions, ...serviceActions };
